<div class="horizontal-selector">
  <button (click)="updateIndex(-1)">
    <div class="icon arrow-left" [inlineSVG]="'assets/icons/icon28-arrow-left.svg'"></div>
  </button>
  @if (templateRef) {
    <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: this.data[this.index] }"></ng-container>
  } @else {
    {{this.data[this.index]}}
  }
  <button (click)="updateIndex(1)">
    <div class="icon arrow-right" [inlineSVG]="'assets/icons/icon28-arrow-right.svg'"></div>
  </button>
</div>
